import { z } from 'zod';

const httpUrlSchema = z.string().refine(
  (value) => {
    try {
      return ['http:', 'https:'].includes(new URL(value).protocol);
    } catch {
      return false;
    }
  },
  { message: 'Expected a valid HTTP(S) URL' },
);

export const tradeInstrumentSchema = z.object({
  instrumentKey: z.string().min(1),
  symbol: z.string().min(1),
  name: z.string().min(1),
  exchange: z.string().min(1),
});

export const technicalIndicatorsSchema = z.object({
  close: z.number().finite(),
  ema20: z.number().finite(),
  ema50: z.number().finite(),
  ema200: z.number().finite(),
  rsi14: z.number().finite(),
  adx14: z.number().finite(),
  atr14: z.number().finite(),
  volumeRatio20: z.number().finite(),
  macd: z.number().finite(),
  macdSignal: z.number().finite(),
  superTrend: z.number().finite(),
  superTrendBullish: z.boolean(),
});

export const relatedNewsSchema = z.object({
  tradeInstrumentKey: z.string().min(1),
  heading: z.string().min(1),
  summary: z.string(),
  shortSummary: z.string(),
  sentiment: z.number().finite().min(-1).max(1),
  thumbnail: z.union([z.literal(''), httpUrlSchema]),
  articleLink: httpUrlSchema,
  publishedTime: z.number().finite(),
  publishedAt: z.string().datetime({ offset: true }),
});

export const marketOpportunitySchema = z.object({
  tradeInstrument: tradeInstrumentSchema,
  signal: z.union([z.literal(3), z.literal(4), z.literal(5)]),
  score: z.number().finite(),
  confidence: z.number().finite().min(0).max(100),
  indicators: technicalIndicatorsSchema,
  suggestedEntry: z.number().finite().nonnegative(),
  stopLoss: z.number().finite().nonnegative(),
  target1: z.number().finite().nonnegative(),
  target2: z.number().finite().nonnegative(),
  reasons: z.array(z.string()),
  evaluatedAtUtc: z.string().datetime({ offset: true }),
  relatedNews: z.array(relatedNewsSchema),
});

export const marketDataResponseSchema = z
  .object({
    count: z.number().int().nonnegative(),
    results: z.array(marketOpportunitySchema),
    disclaimer: z.string().nullable().default(null),
  })
  .refine((value) => value.count === value.results.length, {
    message: 'count must equal the number of results',
    path: ['count'],
  });
